import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getDaftarMaterial = createAsyncThunk('/daftar_material/content', async (nopage) => {
    const userId = localStorage.getItem("userId");
    
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daftarmaterial/${userId}?page=${nopage}`, {})
    
    return response.data;
})

export const daftarmaterialSlice = createSlice({
    name: 'daftar_material',
    initialState: {
        isLoading: false,
        daftar_material : []
    },

    /*extraReducers: {
        [getDaftarMaterial.pending]: state => {
			state.isLoading = true
		},
        [getDaftarMaterial.fulfilled]: (state, action) => {
            state.daftar_material = action.payload.data
			state.isLoading = false
		},
        [getDaftarMaterial.rejected]: state => {
			state.isLoading = false
		},
    }*/

    extraReducers: (builder) => {           
        builder         
        .addCase(getDaftarMaterial.pending, (state) => {
            state.isLoading = true;
        })                   
        .addCase(getDaftarMaterial.fulfilled, (state, action) => {
            state.daftar_material = action.payload.data;
            state.isLoading = false;
        })                              
        .addCase(getDaftarMaterial.rejected, (state) => {
            state.isLoading = false;
        })                   
    }
})


export default daftarmaterialSlice.reducer